/* eslint-disable camelcase */
import React, {
  useState,
  useEffect,
} from 'react';
import {
  useNavigate,
} from 'react-router-dom';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  getStatus,
} from 'redux-resource';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  useClickAway,
} from 'web-hooks';

import {
  Button,
  Select,
  Spinner,
  NotFound,
  ClientSearchOption,
} from 'web-components';

import {
  Flex,
  TextBreadcrumbs,
} from 'web-styled';

import ClientMessages from './ClientMessages';
import ProMessages from './ProMessages';
import * as S from './styled';

const mapState = state => ({
  isPro: coreSelectors.getProfile('is_pro')(state),
  readStatus: getStatus(
    state,
    [
      'conversations.requests.fetchConversationList.status',
    ],
  ),
  updateStatus: getStatus(
    state,
    [
      'programWeeks.requests.addWeek.status',
      'programWeeks.requests.copyWeek.status',
      'programWorkouts.requests.createProgramWorkout.status',
      'programWorkouts.requests.copyWeekWorkouts.status',
    ],
  ),
  clientOptions: coreSelectors.getMessageClientOptions(state),
});

const MessagesPage = () => {
  const navigate = useNavigate();
  const {
    isPro,
    readStatus,
    updateStatus,
    clientOptions,
  } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();
  const [searchIsVisible, setSearchVisible] = useState(false);

  useEffect(() => {
    dispatch(
      coreActions.requestConversationList(),
    );
  }, []);

  const selectRef = useClickAway(
    () => {
      setSearchVisible(false);
    },
    { disabled: !searchIsVisible },
  );

  const Component = isPro ? ProMessages : ClientMessages;

  return (
    <Flex fillSpace column>
      <Flex
        spacing={10}
        flex="0 0 50px"
        width="100%"
        align="center"
        padding="0px 15px"
      >
        <TextBreadcrumbs>
          Messages
        </TextBreadcrumbs>
        <S.Search>
          {searchIsVisible ? (
            <Select
              value=""
              autoFocus
              menuIsOpen
              innerRef={selectRef}
              options={clientOptions}
              components={{ Option: ClientSearchOption }}
              placeholder="Search Client"
              onChange={(item) => {
                setSearchVisible(false);
                if (item?.value) {
                  navigate(`/messages/new/1?recipient=${item.value}`);
                }
              }}
            />
          ) : (
            <Button
              icon="fa fa-plus"
              appearance="success"
              onClick={() => setSearchVisible(true)}
            >
              Add Conversation
            </Button>
          )}
        </S.Search>
      </Flex>
      {readStatus.succeeded && (<Component />)}

      {readStatus.pending && (
        <Spinner message="Loading conversations..." />
      )}

      {updateStatus.pending && (
        <Spinner over />
      )}

      {readStatus.failed && (
        <NotFound title="Error" />
      )}
    </Flex>
  );
};

export default MessagesPage;
